import React, { memo } from "react";
import { ployTheme } from "ui/theme";

// Raw colour values because this control writes styles straight to the DOM node
// (no Chakra prop layer here). The checked fill/border is success.500; the idle
// border is resolved from border.control so it can't drift from the token.
const CHECKED_FILL = "#10B981"; // success.500
const [IDLE_PALETTE, IDLE_STEP] =
  ployTheme.semanticTokens.colors.border.control.split(".");
const IDLE_BORDER: string = ployTheme.colors[IDLE_PALETTE][IDLE_STEP];
const IDLE_FILL = "white";

const CustomCheckbox = memo(
  ({
    checked,
    onChange,
    indeterminate = false,
  }: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    indeterminate?: boolean;
  }) => {
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
      if (ref.current) {
        ref.current.style.backgroundColor = checked ? CHECKED_FILL : IDLE_FILL;
        ref.current.style.borderColor = checked ? CHECKED_FILL : IDLE_BORDER;
        ref.current.setAttribute(
          "data-indeterminate",
          indeterminate ? "true" : "false",
        );
        if (indeterminate) {
          ref.current.style.backgroundColor = CHECKED_FILL;
          ref.current.style.borderColor = CHECKED_FILL;
        }
      }
    }, [checked, indeterminate]);

    return (
      <div
        ref={ref}
        onClick={() => onChange(!checked)}
        style={{
          width: "16px",
          height: "16px",
          borderRadius: "3px",
          border: `1px solid ${IDLE_BORDER}`,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.15s ease",
        }}
      >
        {checked && !indeterminate && (
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 6L9 17L4 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {indeterminate && (
          <div
            style={{ width: "8px", height: "2px", backgroundColor: "white" }}
          ></div>
        )}
      </div>
    );
  },
);

export default CustomCheckbox;
